'use strict';

angular.module('ClinicApp').factory('ReservedAppointmentSlotService', function($http, ClinicConfig, OpencareConstants) {
  function getSearchParams(filters, pagination) {
    filters = filters || {};
    pagination = pagination || {};
    return {
      status: filters.status || undefined,
      date: filters.date || undefined,
      dateGte: filters.dateGte || moment().format(OpencareConstants.apiDateFormat),
      dateLt: filters.dateLt || undefined,
      page: pagination.page || undefined,
      resultsPerPage: pagination.resultsPerPage || undefined,
    };
  }

  return {
    listForProvider: function(providerId, filters, pagination) {
      return $http.get(ClinicConfig.HOSTNAME + '/provider/' + providerId + '/reservedAppointmentSlot', {
        params: getSearchParams(filters, pagination),
      }).then(function(response) {
        return response.data;
      });
    },

    listForProviders: function(providerIds, filters, pagination) {
      return $http.get(ClinicConfig.HOSTNAME + '/provider/reservedAppointmentSlot', {
        params: _.merge(getSearchParams(filters, pagination), {
          'providerIds[]': providerIds,
        }),
      }).then(function(response) {
        return response.data;
      });
    },

    listForClinic: function(clinicId, filters, pagination) {
      return $http.get(ClinicConfig.HOSTNAME + '/clinic/' + clinicId + '/reservedAppointmentSlot', {
        params: getSearchParams(filters, pagination),
      }).then(function(response) {
        return response.data;
      });
    },

    create: function(providerIds, date, time) {
      return $http.post(ClinicConfig.HOSTNAME + '/provider/reservedAppointmentSlot', {
        providerIds: providerIds,
        date: date,
        time: time,
      }).then(function(response) {
        return response.data;
      });
    },

    createForClinic: function(clinicId, date, time) {
      return $http
        .post(ClinicConfig.HOSTNAME + '/clinic/' + clinicId + '/reservedAppointmentSlot', {
          date: date,
          time: time,
        })
        .then(function(response) {
          return response.data;
        });
    },

    remove: function(providerId, reservedAppointmentSlotId) {
      return $http['delete'](ClinicConfig.HOSTNAME + '/provider/' + providerId + '/reservedAppointmentSlot/' + reservedAppointmentSlotId).then(function(response) {
        return response.data;
      });
    },
  };
});
